import { Component, OnInit } from "@angular/core"
import { FormControl, FormGroup, FormGroupDirective, FormGroupName, FormsModule, NgForm, ReactiveFormsModule, Validators } from "@angular/forms";
import { AuthService } from "../services/auth.service";
import { Router } from "@angular/router";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { UsersService } from "../services/users.service";
import { User } from "../models/user.model";
import { MatButton, MatButtonModule } from "@angular/material/button";
//import { MatPseudoCheckboxModule } from "@angular/material/core";
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from "@angular/material/form-field";
import { CommonModule, NgIf } from "@angular/common";
import { MatInputModule } from "@angular/material/input";
import { ErrorStateMatcher } from "@angular/material/core";
import { SocialMediaComponent } from "../share/social-media/social-media.component";

/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}

@Component({
    selector: 'app-auth',
    standalone: true,
    templateUrl: './auth.component.html',
    imports: [
        CommonModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        MatProgressSpinnerModule,
        MatButtonModule,
        MatButton,
        MatCheckboxModule,
        SocialMediaComponent
    ],
    styleUrl: './auth.component.scss'
})

export class AuthComponent implements OnInit {

    emailFormControl = new FormControl('', [Validators.required, Validators.email]);
    passwordFormControl = new FormControl('', [Validators.required, Validators.minLength(6)]);
    matcher = new MyErrorStateMatcher();

    responseState: any = {
        error: false,
    };

    public rememberMe: any = new FormControl(false);

    public error: string = "";

    public form = new FormGroup({
        username: new FormControl(''),
        password: new FormControl('aaa'),
        rememberMe: new FormControl(false)
    });

    ngOnInit(): void {
        this.checkAuthentication();
        //this.authService.isAuthenticated = false;
        //this.authService.setToken("");
        //this.authService.setUser(new User(0, "", "", "", "", 0, ""));
        //this.authService.setUserPermissions([]);
    }

    checkAuthentication() {
        if (this.authService.isAuthenticated) {
            //console.log("Already authenticated")
            this.router.navigate(['main']);
        }
    }

    submit() {
       console.log("Submit")
    }

    constructor(
        private authService: AuthService,
        private userService: UsersService,
        public router: Router
    ) {

    }

    isLoginMode = true;

    login() {
    }

    onSubmit(form: NgForm) {
        //console.log("Submit", form, this.emailFormControl, this.passwordFormControl, this.rememberMe)
        //console.log("matcher", this.matcher)

        /*const credentials = {
            email: form.value.email,
            password: form.value.password
        }*/

        const credentials = {
            email: this.emailFormControl.value,
            password: this.passwordFormControl.value,
            rememberMe: this.rememberMe.value
        }

        console.log("Submit credentials", credentials)
        this.error = "";

        this.authService.login(credentials)
            .subscribe({
                next: (response: any) => {
                    console.log(response);
                    if (response.access_token !== undefined) {
                        this.authService.setToken(response.access_token);
                        this.authService.isAuthenticated = true;
                        this.getUserAfterLogin();
                        //this.router.navigate(['rekbots-list']);
                        sessionStorage.clear();
                        this.router.navigate(['main']);
                    } else {
                        alert("Błędne dane logowania")
                    }
                },
                error: (error) => {
                    console.log("Error", error)

                    if(error.error?.message == "invalid data") {

                        this.error = "Podane hasło lub e-mail są nieprawidłowe. Spróbuj ponownie."

                        /*this.responseState = {
                            error: true
                        }*/
                        }

                    //console.log("responseState", this.responseState)*/


                }   
            })
    }

    getUserAfterLogin() {
        /*this.userService.getUserByToken()
            .subscribe({
                next: (response: any) => {
                    console.log("getUserAfterLogin getUserByToken", response);
                    this.authService.setUser(response.user);
                },
                error: (error) => {
                    console.log("Error", error)
                }
            })*/
    }

    logout() {
        this.authService.setToken("");
    }

    /*onSwitchMode() {
        this.isLoginMode = !this.isLoginMode;
    }*/
}